var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs",attrs:{"name":"tab"}},_vm._l((_vm.list),function(title,index){return _c('div',{key:index,class:index === _vm.selected ? 'active' : 'inactive',on:{"click":function($event){index !== _vm.selected ? _vm.select(index) : null}}},[_vm._v("\n        "+_vm._s(title)+"\n    ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caaeb1f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/Tab.vue
// module id = null
// module chunks = 